import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var LearningFoundationLeaderGetCentralizedDataQueryDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "LearningFoundationLeaderGetCentralizedDataQuery"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "security"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "current_session"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "application_roles"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "application_products"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};

/**
 * __useLearningFoundationLeaderGetCentralizedDataQueryQuery__
 *
 * To run a query within a React component, call `useLearningFoundationLeaderGetCentralizedDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningFoundationLeaderGetCentralizedDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningFoundationLeaderGetCentralizedDataQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useLearningFoundationLeaderGetCentralizedDataQueryQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(LearningFoundationLeaderGetCentralizedDataQueryDocument, options);
}
export function useLearningFoundationLeaderGetCentralizedDataQueryLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(LearningFoundationLeaderGetCentralizedDataQueryDocument, options);
}